import { render, staticRenderFns } from "./ChangePriceRecordTable.vue?vue&type=template&id=13a96f3e&"
import script from "./ChangePriceRecordTable.vue?vue&type=script&lang=js&"
export * from "./ChangePriceRecordTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports